import "core-js/modules/es.function.name.js";
import Wfd from './components/Wfd';
var install = function install(Vue) {
  Vue.component(Wfd.name, Wfd);
};
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}
export default Wfd;